export const ProjectData = [
  {
    id: 1,
    title: "Sarucci",
    role: "Consultant",
    duration: "2025 - Present",
    about:
      "Sarucci is an AI-driven revenue management and LLM-SEO platform for the hospitality industry. It combines a multi-strategy hotel pricing engine with a multi-agent AI advisory layer and competitor market intelligence, helping multi-tenant hotel portfolios optimize revenue while measuring and improving their brand visibility across modern AI assistants.",
    contributions: [
      "Architected a <strong>multi-strategy hotel pricing engine</strong> — rule-based, manual, and reinforcement-learning policies with guardrails and explainability — with real-time booking-pace analysis using <strong>FastAPI, SQLAlchemy 2.0, and React/Redux</strong>, optimizing revenue across a multi-tenant portfolio",
      "Built a <strong>multi-agent AI advisory layer</strong> on <strong>Claude/OpenAI</strong> (revenue, market, yield, and competitor agents with <strong>tool-calling, RAG, and streaming</strong>), exposed via a conversational <strong>React</strong> UI with live charts, <strong>WebSocket</strong> streaming, and voice I/O",
      "Engineered <strong>competitor market intelligence and data pipelines</strong> — <strong>Playwright</strong> stealth scraping, <strong>Pub/Sub</strong> bulk processing, and PMS (Cloudbeds/OHIP), Zoho CRM, holiday, and on-the-books integrations — visualized in dashboards with geospatial mapping and pricing heatmaps",
      "Shipped an <strong>LLM-SEO brand-visibility SaaS</strong> (<strong>FastAPI/React/Firestore on Cloud Run</strong>) scoring hotel presence across <strong>ChatGPT, Gemini, and Claude</strong>, plus an automated AI-readiness website auditor with fix generation and subscription billing",
    ],
    tags: [
      "FastAPI",
      "Python",
      "SQLAlchemy 2.0",
      "React.js",
      "Redux Toolkit",
      "LLM APIs",
      "AI Agents",
      "RAG",
      "WebSocket",
      "Playwright",
      "GCP",
      "Firestore",
      "Cloud Run",
      "Pub/Sub",
    ],
    links: [
      { label: "Sarucci Platform", url: "https://sarucci.com" },
      { label: "LLM-SEO Tool", url: "https://appearinaisearch.com" },
    ],
    demo: "#",
    github: "#",
  },
  {
    id: 2,
    title: "DataWing AI",
    role: "Consultant",
    duration: "Jan 2025 - July 2025",
    about:
      "DataWing AI is a comprehensive data analytics platform that lets organizations explore, analyze, and visualize their data through AI-driven insights. It integrates with multiple data sources and CRMs, turning natural-language questions into intelligent queries and surfacing actionable, context-aware insights through LLM-powered retrieval.",
    contributions: [
      "Enhanced platform usability and data exploration by redesigning core UI workflows using <strong>React.js, TypeScript, Redux Toolkit, and Tailwind CSS</strong>",
      "Built <strong>LLM-powered query generation</strong> that converts natural-language prompts into accurate analytics queries, using <strong>retrieval-augmented (RAG)</strong> context over connected data sources",
      "Developed backend APIs with <strong>Node.js and Express</strong> to support <strong>AI-driven query generation and real-time data visualization</strong>, ensuring accurate and responsive analytics",
      "Implemented provider integrations (<strong>e.g., HubSpot</strong>) enabling seamless connection between DataWing AI and third-party CRMs, improving <strong>client adoption rate</strong>",
      "Optimized data-processing workflows and improved system performance for handling <strong>large datasets</strong> at scale",
      "Collaborated with the product team to define technical requirements and deliver <strong>scalable solutions</strong>",
    ],
    tags: [
      "React.js",
      "TypeScript",
      "Redux Toolkit",
      "Tailwind CSS",
      "Node.js",
      "Express.js",
      "LLM APIs",
      "RAG",
      "Data Visualization",
      "REST APIs",
      "Firebase",
    ],
    demo: "#",
    github: "#",
  },
  {
    id: 3,
    title: "Psynetics",
    role: "Consultant",
    duration: "Oct 2024 - July 2025",
    about:
      "Psynetics is an AI-assisted workflow automation platform that lets users create, manage, and execute complex business processes through an intuitive visual interface. Its drag-and-drop editor lets teams design automated, agent-driven workflows with real-time monitoring and status tracking.",
    contributions: [
      "Designed and implemented the <strong>entire frontend architecture from scratch</strong> using <strong>React.js, TypeScript, and XY Flow</strong>, ensuring scalability and maintainability for future features",
      "Built a <strong>drag-and-drop workflow editor</strong> with <strong>real-time node and edge management, custom node types, and live status monitoring</strong>, enabling users to orchestrate <strong>AI agent workflows</strong> visually",
      "Integrated <strong>LLM-powered nodes</strong> into the workflow engine, enabling prompt-driven automation steps within user-defined pipelines",
      "Implemented <strong>complex state management</strong> for workflow execution and real-time updates across a responsive, cross-browser interface",
      "Created <strong>reusable UI components</strong> and established coding standards for the development team",
      "Integrated with backend services to handle <strong>workflow execution and monitoring</strong>",
    ],
    tags: [
      "React.js",
      "TypeScript",
      "XY Flow",
      "Redux Toolkit",
      "Tailwind CSS",
      "LLM APIs",
      "AI Agents",
      "HTML5",
      "CSS3",
    ],
    demo: "#",
    github: "#",
  },
];
